"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const makeBox = ({
  gutters,
  palette
}) => ({
  palette: {
    box: {
      default: {
        primary: {
          color: palette.text.primary,
          backgroundColor: palette.background.primary.main
        },
        secondary: {
          color: palette.text.secondary,
          backgroundColor: palette.background.secondary
        },
        tertiary: {
          color: palette.text.tertiary,
          backgroundColor: palette.background.tertiary
        }
      }
    }
  },
  gutters: {
    box: {
      page: {
        xs: gutters.page.xs,
        sm: gutters.page.sm,
        md: gutters.page.md,
        lg: gutters.page.lg,
        xl: gutters.page.xl
      },
      condensed: {
        xs: gutters.condensed.xs,
        sm: gutters.condensed.sm,
        md: gutters.condensed.md,
        lg: gutters.condensed.lg,
        xl: gutters.condensed.xl
      },
      navigation: {
        xs: gutters.page.xs,
        sm: gutters.page.xs,
        md: `${parseInt(gutters.page.md) / 2}em`,
        lg: `${parseInt(gutters.page.lg) / 2}em`,
        xl: `${parseInt(gutters.page.xl) / 2}em`
      }
    }
  }
});
var _default = exports.default = makeBox;